import { transportPage, transportPageImage } from "#templates/views/article_transportpage_template";
import { cardsFront } from "#templates/modules/cardlisting";
import { newslistFront } from "#templates/modules/newslist";
import { createNanoId } from "#scripts/general_functions.js";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";

export const articleTransportpage = (article) => {
	const contentHtml = document.getElementById("contentHtml");
	const maincontent = document.getElementById("maincontent");

	contentHtml.classList.remove("container");
	maincontent.classList.add("transportside");
	// add bg color to bradcrumb div
	// #maincontent .container .row
	const orgHtml = document.querySelector("#maincontent .container").outerHTML;
	const newHtml = `<div class='transportside__breadcrumb__container'>${orgHtml}</div>`;
	document.querySelector("#maincontent .container").outerHTML = newHtml;

	const meta = article.metaObject || false;
	const metaData = JSON.parse(decodeURIComponent(meta));
	const imgId = createNanoId();
	const hasImage = !!metaData.imageContentId;
	const mainImage = transportPageImage({ id: imgId });
	// `
	//     <div class="article__introimage__container col-md-4">
	//         <img src="" style="width:200px;height:200px;" alt="" class="article__introimage" id="${imgId}" >
	//     </div>`;

	getImageByContentId(metaData.imageContentId, (img) => {
		if (img.url !== undefined && img.url.length > 0) {
			const elm = document.getElementById(`${imgId}`);
			if (elm) {
				elm.setAttribute("data-src", img.url);
				elm.setAttribute("src", "/images/transparent.png");
				elm.setAttribute("data-imagehotspot", `${img.imageHotspotX},${img.imageHotspotY}`);
			}
			setResponsiveImage(elm);
		}
	});
	const maxItems = 100;
	const moduleTitle = "";
	const moduleMoreText = "";
	const moduleMoreLink = "";
	const bodyText = article.content;
	let content = "";
	if (article.content.match(/\[modul:.+?\]/gim)) {
		for (const me of article.content.match(/\[modul:.+?\]/gim)) {
			const modulename = me.replace("[modul:", "").replace("]", "");
			if (modulename.match("nyhetliste")) {
				content = newslistFront(maxItems, moduleTitle, "card__design__news1");
			} // else {
			//     content = cardsFront(category, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, "card__design__3");
			// }
		}
	} else {
		const category = article.categories[0].categoryId;
		content = cardsFront(category, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, "card__design__3", true, "sortByTitle");
	}

	// let content = cardsFront(category, maxItems, moduleTitle, moduleMoreText, moduleMoreLink, moduleCardDesign);
	return transportPage({
		pageType: article.pageTypeId,
		title: article.title,
		parsedIntro: article.metaDynamic.Intro,
		hasImage,
		mainImage,
		bodyText,
		bodyTextJustify: window.serverdata.configMeta.aim.style?.view?.transport__content__text_justify || "center",
		content,
	});
};
